var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('b-skeleton',{attrs:{"width":"20%"}}),_c('b-skeleton',{attrs:{"width":"40%"}}),_c('b-skeleton',{attrs:{"width":"80%"}}),_c('b-skeleton',{attrs:{"width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }